export default __webpack_public_path__ + "static/media/BWCCscreenshot.b706e737.JPG";